"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var angular_jwt_1 = require("@auth0/angular-jwt");
var service_service_1 = require("./../../../Services/service.service");
var AuthHeaders_1 = require("src/app/api/AuthHeaders");
var i0 = require("@angular/core");
var i1 = require("@angular/router");
var i2 = require("@auth0/angular-jwt/src/jwthelper.service");
var i3 = require("../../../Services/service.service");
var MobileAuthGuard = /** @class */ (function () {
    function MobileAuthGuard(route, jwtHelper, services) {
        this.route = route;
        this.jwtHelper = jwtHelper;
        this.services = services;
    }
    MobileAuthGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var token = AuthHeaders_1.getAuthToken();
            if (token && !_this.jwtHelper.isTokenExpired(token)) {
                console.log("g-true");
                return rs(true);
            }
            _this.route.navigate(['/login']);
            console.log("g-false");
            return rs(false);
        });
    };
    MobileAuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MobileAuthGuard_Factory() { return new MobileAuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.JwtHelperService), i0.ɵɵinject(i3.MainService)); }, token: MobileAuthGuard, providedIn: "root" });
    return MobileAuthGuard;
}());
exports.MobileAuthGuard = MobileAuthGuard;
